export const hy = {
  title: 'Հողածածկ 2000-2020',
  subtitle: 'ՈւՄԴ',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Գործառույթ',
      value: '2000 եւ 2020թ. հողերի օգտագործման եւ հողածածկման գլոբալ քարտեզ',
    },
    {
      label: 'Բանաձեւ',
      value: '30 մետր',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Գլոբալ',
    },
    {
      label: 'Աղբյուր',
      value: 'ՈւՄԴ',
    },
    {
      label: 'Հաճախականություն',
      value: '',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: '',
    },
    {
      label: 'Զգուշացումներ',
      value:
        '- Երկրի ծածկույթի քարտեզագրումը սահմանափակված էր Լանդսատի հստակ երկնիշ տվյալների մատչելիությամբ: Լանդսատի դիտարկման ժամանակի շարքի անավարտությունը նվազեցնում է քարտեզի ճշգրտությունը այն շրջաններում, որտեղ ամպերի մշտական ծածկույթ կա: \n- Discrete land cover classes mapping in heterogeneous landscapes was consed by the high proportion of mixed pixels at the Landsat spatial resolution. LULC-ի դասերի մեծ մասը ավելի մեծ քարտեզի ճշգրտություն ունի մեծ համասեռ տարածքների նկատմամբ՝ համեմատած մասնատված բնապատկերների եւ դասերի եզրերի հետ։ \n- LCLU-ի տարբեր դասերի սպեկտրալ նմանությունը կարող է բացառել դասակարգային խտրականությունը:\n- Անտառային բարձրության արտադրանքն ունի geDI տվյալների որակի եւ Landsat տվյալների մատչելիության հետ կապված խնդիրներ: 2000-2020 թվականների ընթացքում անտառի բարձրության փոքր փոփոխությունները կարող են չնշել անտառների իրական կառուցվածքի փոփոխությունը, այլ ներկայացնել մոդելային ելքերի աղմուկը: \n- Դինամիկ դասերը (LCLU դասի կորուստ եւ շահում) ստատիկ քարտեզների համեմատ ունեն ավելի ցածր ճշգրտումներ: \n- Քարտեզի վրա հիմնված գնահատականները բավարար չեն ազգային եւ միջազգային հաշվետվությունների համար՝ պայմանավորված քարտեզի անորոշության անհայտ տարածական եւ ժամանակային փոփոխականությամբ:',
    },
    {
      label: 'Լիցենզիա',
      value: 'Creative Commons Attribution License (https://glad.umd.edu/dataset/GLCLUC2020)',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Հողերի օգտագործման եւ հողածածկման համաշխարհային քարտեզները ստեղծվել են Global Land Analysis and Discovery Lab (GLAD) լաբորատորիայի կողմից։ Տվյալները հասանելի են 2000 եւ 2020 թթ. 30 մ տարածական բանաձեւով։ ԳԼԱԴ լաբորատորիան կիրառել է սպատիոմփորիկորեն հետեւողական [Landsat Analysis Ready Data (GLAD ARD)](https://glad.umd.edu/ard)՝ քսան տարվա ընթացքում անտառային ծավալների եւ բարձրության, մշակաբույսերի, կառուցված հողերի, մակերեսային ջրերի եւ պերմանենտ ձյան ու սառույցի փոփոխությունները չափելու համար։ Յուրաքանչյուր թեմատիկ արտադրանք ինքնուրույն ստացվել է նորագույն, տեղական եւ տարածաշրջանային կալիբրացված մեքենայական ուսուցման գործիքների կիրառմամբ: Տվյալների թերթիկը վավերացվել է վիճակագրական նմուշի միջոցով, որը հաստատում է դրա բարձր ճշգրտությունը։ ՈւՄԴ-ի աշխարհագրական գիտությունների բաժանմունքի Գլոբալ հողերի վերլուծության եւ բացահայտման լաբորատորիայի (GLAD) լաբորատորիան ուսումնասիրում է գլոբալ հողային մակերեւույթի փոփոխության մեթոդները, պատճառները եւ ազդեցությունը: Երկրի դիտարկման պատկերը տվյալների հիմնական աղբյուրն է, իսկ ցամաքի ծածկույթի ծավալն ու փոփոխությունը հետաքրքրության հիմնական թեման է։ ԳԼԱԴ-ը ձգտում է ստեղծել գիտության նոր գաղափարներ հողային ռեսուրսների վերաբերյալ, կրթել հեռավոր սենսացիայի վրա հիմնված հողերի փոփոխության գիտնականների հաջորդ սերնդին եւ տարածել հողերի մոնիտորինգի հնարավորությունները երկրի եւ միջազգային գործունեության համար։',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Potapov P., Hansen M.C., Pickens A., Hernandez-Serna A., Tyukavina A., Turubanova S., Zalles V., Li X., Khan A., Stolle F., Harris N., Song X.-P., Baggett A., Kommareddy I., Kommareddy A. (2022) The global 2000-2020 land cover and land use change dataset derived from the Landsat archive: first results. Frontiers in Remote Sensing. [https://doi.org/10.3389/frsen.2022.856903](https://doi.org/10.3389/frsen.2022.856903). Accessed through Resource Watch, (date). [www.resourcewatch.org](https://www.resourcewatch.org).',
  },
};
